import { useContext } from 'react';

import { UpdateContext } from '~contexts/update';

export const useUpdateAvailable = () => {
  const updateContext = useContext(UpdateContext);

  // if `undefined`, throw an error
  if (updateContext === undefined) {
    throw new Error('Update context was used outside of its Provider');
  }

  return { ...updateContext };
};
